import LinkIcon from '@material-ui/icons/Link';
import React, { useCallback } from 'react';
import Box from '@material-ui/core/Box';
import { useNavigate } from 'react-router';
import { gql } from '@apollo/client';
import { Loader } from 'lib/icons';
import { useTranslation } from 'react-i18next';
import BaseButton from './form/BaseButton';
import { useQueryCached } from './utils/graphql';
import useLocalStorage from '../custom_hooks/useLocalStorage';

const versionRex = /(.*)\.(.*)\.[\d]+/;

export default function GpexeVersion() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [beVersion, setBeVersion] = useLocalStorage('be_version', '');
  const [beVersionNotice, setBeVersionNotice] = useLocalStorage('be_version_notice', '');
  const { data: versionData, loading } = useQueryCached(gql`query gpexeVersion { res: versionQuery }`, {
    fetchPolicy: 'no-cache',
    onCompleted(data) {
      const beVersionString = data?.res.split(' ')[0];

      const v1ex = beVersionString.match(versionRex);
      const v2ex = beVersion.match(versionRex);

      if (!v2ex || !v1ex || v1ex[0] !== v2ex[0] || v1ex[1] !== v2ex[1] || v1ex[2] !== v2ex[2]) {
        setBeVersion(beVersionString);
        setBeVersionNotice(1);
      }
    },
  });

  const [version, branchName] = versionData?.res ? versionData?.res?.split(' ') : ['', ''];
  const versionString = branchName?.includes('release') ? version : versionData?.res || '';

  const handleVersionClick = useCallback(() => {
    navigate('/changelog');
    setBeVersionNotice('');
  }, [navigate, setBeVersionNotice]);

  if (loading) return <Loader />;

  if (versionData?.res === 'unconfigured') {
    return (
      <Box className="gpexe-version-button">
        <BaseButton
          flat
          style={{
            marginTop: '5px',
          }}
          startIcon={<LinkIcon />}
          onClick={() => navigate('/changelog')}
          hoverAll
        >
          v. unconfigured
        </BaseButton>
      </Box>
    );
  }

  return (
    <Box className="gpexe-version-button">
      <BaseButton
        flat
        style={{
          marginTop: '5px',
        }}
        startIcon={<LinkIcon />}
        onClick={handleVersionClick}
        hoverAll
        badge={beVersionNotice ? t('gpexe.vesion.new', 'new') : undefined}
        badgeClassName={beVersionNotice ? 'notice' : ''}
      >
        {`v. ${versionString}`}
      </BaseButton>
    </Box>
  );
}
